const { roles } = require("../../config/ProjectConfig");

const isUserRole = (role) => role === roles[1];

export default isUserRole